// import React, { useEffect, useState } from "react";
// import "./Plans.css";
// import Loader from "../../Components/Loader/Loader";
// import { useDispatch, useSelector } from "react-redux";
// import { ApiPaths } from "../../Config/ApiPath";
// import useAxiosHelper from "../../Common/AxiosHelper";
// import { setUserPersonalInfo } from "../../Redux/ProfileDataSlice";
// import { setIncomeWallet } from "../../Redux/IncomeWallet";
// import { BasicInfo, toastFailed, toastSuccess } from "../../Config/BasicInfo";
// import USDTIncreaseAllowance from "../../Common/USDTIncreaseAllowance";
// import ATMTokenIncreaseAllowance from "../../Common/ATMTokenIncreaseAllowance";
// import { setIncomeData } from "../../Redux/IncomeWallet";
// import { ethers } from "ethers";
// import FundWallet from "./../../Images/fundWallet.png";
// import CryptoGateway from "./../../Images/Web3.png";
// import ContractDetails from "../../Contracts/ContractDetails";
// import ArrayToObject from "../../Common/ArrayToObject";
// import OrderHistory from "./Order";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import { Row, Col } from "react-bootstrap";
// import GetChainId from "../../Common/GetChainId";
// import { AppKitProvider } from "../../Components/AppKitProvider";
// import Tether from "./../../Images/tether-usdt-logo.png";
// const Plans = () => {
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const { planId, minAmount, maxAmount } = location.state;
//   const [loading, setLoading] = useState(false);
//   const [amount, setAmount] = useState(minAmount);
//   const [amountError, setAmountError] = useState("");
//   const [username, setUsername] = useState("");
//   const [fundBalance, setFundBalance] = useState();
//   const acc = useSelector((state) => state.account.value);
//   const [selectPackage, setSelectPackage] = useState([]);
//   const { AxiosPost, AxiosGet } = useAxiosHelper();
//   const [load, setLoad] = useState(false);
//   const profileData = useSelector(
//     (state) => state.profileData.userPersonalInfo
//   );
//   const [showPopUp, setShowPopUp] = useState(false);
//   const [updateOrderList, setUpdateOrderList] = useState(false);
//   const [companyData, setCompanyData] = useState([]);
//   const [usdt, setUsdt] = useState(false);
//   const [atm, setAtm] = useState(false);
//   const [show, setShow] = useState(false);
//   const [companyDetails, setCompanyDetails] = useState();
//   const [userId, setUserId] = useState("");
//   const [existUserName, setExistUserName] = useState({});
//   const [typingTimeout, setTypingTimeout] = useState(null);
//   const [selectedToken, setSelectedToken] = useState();
//   const [selectIncome, setSelectIncome] = useState("");
//   const incomeData = useSelector((state) => state.incomeData.incomeWallet);

//   const navigate = useNavigate();

//   var x = 0;
//   useEffect(() => {
//     if (x == 0) {
//       FetchData();
//       CompanyInfo();
//       getPackages();
//       x++;
//     }
//   }, []);

//   async function CompanyInfo() {
//     try {
//       const data = localStorage.getItem("companyData");
//       setCompanyData(JSON.parse(data));
//     } catch (error) {
//       BasicInfo.isDebug && console.log(error);
//     }
//   }
//   const getPackages = async () => {
//     try {
//       const response = await AxiosGet(ApiPaths.getPackages);
//       console.log("packages response", response?.packages);

//       setSelectPackage(response?.packages);
//     } catch (error) {
//       BasicInfo.isDebug && console.error("Error fetching packages:", error);
//     }
//   };

//   const handleChange = (e) => {
//     const selectedIndex = e.target.value;
//     setSelectIncome(selectedIndex);
//     console.log(e.target.value, "ioioioioio");
//     // let i = e.target.value;
//     // setselactedPackage(selectPackage[i]);
//   };

//   const isUserExist = async () => {
//     setLoad(true);

//     if (!userId) {
//       setExistUserName({ name: ". . .", color: "var(--textColor)" });
//       setLoad(false);
//       return;
//     }
//     try {
//       setLoad(true);
//       const body = {
//         username: userId,
//       };
//       console.log("body", body);
//       const res = await AxiosPost(ApiPaths.checkSponsor, body);
//       if (res) {
//         toastSuccess(res?.message);
//         setExistUserName({ name: res.name, color: "green" });
//       } else {
//         // setExistUserName("User not exists");
//       }
//     } catch (e) {
//       // toastFailed(e?.message);
//       setExistUserName({ name: "User not exists", color: "red" });
//     } finally {
//       setLoad(false);
//     }
//   };

//   useEffect(() => {
//     if (typingTimeout) {
//       clearTimeout(typingTimeout);
//     }
//     setTypingTimeout(
//       setTimeout(() => {
//         isUserExist();
//       }, 1000) // 500ms debounce delay
//     );
//     return () => clearTimeout(typingTimeout);
//   }, [userId]);

//   async function checkValidation() {
//     console.log("userId?.length", userId?.length);
//     if (userId?.length > 0) {
//       return true;
//     } else {
//       toastFailed("Invalid Data");
//       return false;
//     }
//   }

//   async function TopUp() {
//     const valid = await checkValidation();
//     if (valid == true) {
//       try {
//         setLoading(true);
//         const body = {
//           amount: amount,
//           planId: planId,
//           username: userId,
//         };
//         console.log("body", body);
//         const res = await AxiosPost(ApiPaths.topUp, body);
//         console.log("ressss", res);
//         toastSuccess(res?.message);
//         navigate("/dashboard");
//         setLoading(false);
//         setAmount();
//         setSelectIncome("");
//       } catch (e) {
//         toastFailed(e?.message);
//       } finally {
//         setLoading(false);
//       }
//     }
//   }

//   async function FetchData() {
//     try {
//       const [res1, res2] = await Promise.all([
//         AxiosGet(ApiPaths.getProfile),
//         AxiosGet(ApiPaths.getWallets),
//       ]);
//       if (res1) {
//         dispatch(setUserPersonalInfo(res1));
//       }
//       if (res2?.wallets) {
//         dispatch(setIncomeWallet(res2?.wallets));
//         const objectWalletData = ArrayToObject(res2?.wallets);
//         setFundBalance(objectWalletData?.fund_wallet?.value);
//       }
//     } catch (error) {
//       toastFailed("error message");
//     }
//   }
//   return (
//     <>
//       {loading ? <Loader /> : null}
//       <section className="dashboard">
//         <h1 className="textHeadingWithMargin mt-0 mt-4">Package Activation</h1>
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//           }}
//         >
//           <div className="addfundDiv inputPrimary capping-card">
//             <h1>Activation</h1>
//             <div className="subscriptionWallets">
//               {incomeData?.map((x) => {
//                 return (
//                   x?.slug == "fund_wallet" && (
//                     <div className="fundWallet" key={x?.name}>
//                       <p>{x?.name}</p>
//                       <h5>
//                         {" "}
//                         {companyData?.token_sign}
//                         {parseFloat(Math.floor(x?.value * 100) / 100).toFixed(
//                           2
//                         )}
//                       </h5>
//                     </div>
//                   )
//                 );
//               })}
//             </div>
//             <div className="registerInput_inner">
//               <div className="d-flex justify-between">
//                 <label htmlFor="userId">User ID</label>
//                 <label
//                   style={{
//                     textAlign: "end",
//                     color: existUserName?.color || "var(--textColor)",
//                   }}
//                   htmlFor="userId"
//                 >
//                   {loading && userId ? "Loading..." : existUserName?.name}
//                 </label>
//               </div>
//               <input
//                 type="text"
//                 placeholder="Enter User ID"
//                 value={userId}
//                 onChange={(e) => setUserId(e.target.value)}
//               />
//             </div>
//             {/* <label>Select Package</label>
//             <select
//               className="mb-2 select"
//               value={selectIncome}
//               onChange={handleChange}
//             >
//               <option value="0">Select Package</option>
//               {selectPackage?.map((x, i) => {
//                 return (
//                   <option key={i} value={x?.planId}>
//                     {x?.package?.name}
//                   </option>
//                 );
//               })}
//               ;
//             </select> */}
//             <label htmlFor="Amount">Amount({companyData?.token_sign})</label>
//             <input
//               type="number"
//               className="inputPrimary"
//               placeholder="Enter Amount"
//               style={{ borderRadius: "5px", padding: "8px 20px" }}
//               value={amount}
//               onChange={(e) => setAmount(e.target.value)}
//               min={minAmount}
//               max={maxAmount}
//             />
//             <p className="errorMsg">{amountError}</p>
//             {minAmount && maxAmount && (
//               <span
//                 style={{
//                   marginTop: "0px",
//                   color: "var(--colorPrimary)",
//                   fontSize: "12px",
//                 }}
//               >
//                 Min. Amount: {companyData?.currency_sign}
//                 {minAmount} and Max. Amount: {companyData?.currency_sign}
//                 {maxAmount}
//               </span>
//             )}
//             <button
//               className="btnPrimary mt-3"
//               onClick={TopUp}
//               disabled={existUserName?.color !== "green"}
//               // onClick={() => setShow(true)}
//             >
//               Proceed
//             </button>
//           </div>
//         </div>
//         <OrderHistory updateOrderList={updateOrderList} />
//       </section>
//     </>
//   );
// };

// export default Plans;

// function PopUp({ TopUp, orderWithDap, amount, onClose, onTopUpSuccess }) {
//   return (
//     <>
//       <div className="otpSection" style={{ zIndex: "999" }}>
//         <div className="PaymentOption">
//           <div className="d-flex justify-content-between">
//             <div></div>
//             <div>
//               <p style={{ marginTop: "10px" }} className="textHeading">
//                 Select Method{" "}
//               </p>
//             </div>
//             <div className="d-flex justify-content-end">
//               <button className="popUpCloseButton" onClick={onClose}>
//                 &times;
//               </button>
//             </div>
//           </div>

//           <Row
//             md="12"
//             style={{ marginTop: "5%", padding: "25px 20px", gap: "10px" }}
//           >
//             <Col md="6">
//               <div className="paymentTypeOption" style={{ display: "flex" }}>
//                 <img
//                   src={CryptoGateway}
//                   width="100%"
//                   height="130px"
//                   style={{ margin: "auto", cursor: "pointer" }}
//                   onClick={orderWithDap}
//                 />
//               </div>
//             </Col>
//             <Col>
//               <div className="paymentTypeOption" style={{ display: "flex" }}>
//                 <img
//                   src={FundWallet}
//                   width="100%"
//                   height="130px"
//                   style={{ margin: "auto", cursor: "pointer" }}
//                   onClick={TopUp}
//                 />
//               </div>
//             </Col>
//           </Row>
//         </div>
//       </div>
//     </>
//   );
// }

import React, { useEffect, useState } from "react";
import "./Plans.css";
import Loader from "../../Components/Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import { ApiPaths } from "../../Config/ApiPath";
import useAxiosHelper from "../../Common/AxiosHelper";
import { setUserPersonalInfo } from "../../Redux/ProfileDataSlice";
import { setIncomeWallet } from "../../Redux/IncomeWallet";
import { BasicInfo, toastFailed, toastSuccess } from "../../Config/BasicInfo";
import USDTIncreaseAllowance from "../../Common/USDTIncreaseAllowance";
import { ethers } from "ethers";
import FundWallet from "./../../Images/fundWallet.png";
import CryptoGateway from "./../../Images/Web3.png";
import ContractDetails from "../../Contracts/ContractDetails";
import ArrayToObject from "../../Common/ArrayToObject";
import OrderHistory from "./Order";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import GetChainId from "../../Common/GetChainId";
import { AppKitProvider } from "../../Components/AppKitProvider";
import { Calendar, Clock } from "lucide-react";
const Plans = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { planId, minAmount, maxAmount } = location.state;
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState(minAmount);
  const [amountError, setAmountError] = useState("");
  const [username, setUsername] = useState("");
  const [fundBalance, setFundBalance] = useState();
  const acc = useSelector((state) => state.account.value);
  const [selectPackage, setSelectPackage] = useState([]);
  const { AxiosPost, AxiosGet } = useAxiosHelper();
  const profileData = useSelector(
    (state) => state.profileData.userPersonalInfo
  );
  const [showPopUp, setShowPopUp] = useState(false);
  const [updateOrderList, setUpdateOrderList] = useState(false);
  const [companyData, setCompanyData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);
  const [currentTime, setCurrentTime] = useState(new Date());
  useEffect(() => {
    if (profileData?.username) {
      setUsername(profileData?.username);
    }
  }, [profileData]);

  useEffect(() => {
    FetchData();
    CompanyInfo();
    getPackages();
  }, []);

  async function CompanyInfo() {
    try {
      const data = localStorage.getItem("companyData");
      setCompanyData(JSON.parse(data));
    } catch (error) {
      BasicInfo.isDebug && console.log(error);
    }
  }
  const getPackages = async () => {
    try {
      const response = await AxiosGet(ApiPaths.getPackages);
      console.log("packages response", response?.packages);

      setSelectPackage(response?.packages?.planId);
    } catch (error) {
      BasicInfo.isDebug && console.error("Error fetching packages:", error);
    }
  };
  const DepositFunc = async () => {
    // console.log("function called----------------DepositFunc")
    BasicInfo.isDebug && console.log("working");
    // if (amount <= 0 || amount % 100 !== 0) {
    //   toastFailed("Please enter a valid amount (multiple of 100)");
    //   return;
    // }
    if (!acc || acc?.length == 0) {
      toastFailed("Please connect your wallet");
      return;
    }
    try {
      setLoading(true);
      const chain = await GetChainId();
      if (chain == false) {
        setLoading(false);
        toastFailed("Wrong network");
        return;
      }
      // console.log("GetChainId exceduted-----")
      const body = {
        planId: planId,
        amount: amount,
      };
      console.log("body", body);
      const tempDepositData = await AxiosPost(ApiPaths.placeOrderwithdap, body);
      BasicInfo.isDebug && console.log("tempDepositData", tempDepositData);
      Stake(amount, tempDepositData?.orderDetail?.order_Id);
    } catch (error) {
      BasicInfo.isDebug &&
        console.error("Error fetching wallet details:", error);
      toastFailed(error?.message);
      setLoading(false);
    } finally {
      setUpdateOrderList((prev) => !prev); // Trigger order list update
    }
    setShowPopUp(false);
  };
  async function Stake(amount, orderId) {
    setLoading(true);
    try {
      const { ethereum } = window;
      if (ethereum) {
        const allowance = await USDTIncreaseAllowance(amount);
        if (allowance === true) {
          console.log("amount", amount);
          const newAmount = ethers.utils.parseUnits(amount.toString(), 18);
          const provider = new ethers.providers.Web3Provider(ethereum);
          const signer = provider.getSigner();
          const contractInstance = new ethers.Contract(
            ContractDetails.contract,
            ContractDetails.contractABI,
            signer
          );
          console.log("working allowance done");
          console.log("orderId", orderId);
          console.log("newAmount", newAmount);
          let inc = await contractInstance.placeOrderAndPay(
            newAmount,
            orderId,
            {
              value: ethers.utils.parseEther("0"),
            }
          );
          console.log("first transection", inc);
          const res = await inc.wait();
          BasicInfo.isDebug && console.log("inc", res);
          BasicInfo.isDebug && console.log("blockNumber", res?.blockNumber);
          DepositConfirm(res?.blockNumber);
          // toastSuccess("Staking Successfull")
          // navigate("/dashboard");
          // setUpdateOrderList(prev => !prev); // Trigger order list update
        } else {
          setLoading(false);
        }
      } else {
        alert();
      }
    } catch (error) {
      // setUpdateOrderList(prev => !prev); // Trigger order list update
      toastFailed("Transaction Failed");
      BasicInfo.isDebug && BasicInfo.isDebug && console.log("error", error);
      setLoading(false);
    } finally {
      setUpdateOrderList((prev) => !prev); // Trigger order list update
    }
  }
  const DepositConfirm = async (blockNum) => {
    BasicInfo.isDebug && console.log("working");
    try {
      setLoading(true);
      const body = {
        blockNumber: blockNum,
      };
      console.log("DepositConfirm body", body);
      const confirmDepositData = await AxiosPost(ApiPaths.confirmOrder, body);
      toastSuccess(confirmDepositData?.message);
      setAmount("");

      BasicInfo.isDebug &&
        console.log("confirmDepositData", confirmDepositData);
    } catch (error) {
      BasicInfo.isDebug &&
        console.error("Error fetching wallet details:", error);
      toastFailed(error?.message);
    } finally {
      setLoading(false);
      setUpdateOrderList((prev) => !prev);
    }
  };

  async function FetchData() {
    try {
      const [res1, res2] = await Promise.all([
        AxiosGet(ApiPaths.getProfile),
        AxiosGet(ApiPaths.getWallets),
      ]);
      if (res1) {
        dispatch(setUserPersonalInfo(res1));
      }
      if (res2?.wallets) {
        dispatch(setIncomeWallet(res2?.wallets));
        const objectWalletData = ArrayToObject(res2?.wallets);
        setFundBalance(objectWalletData?.fund_wallet?.value);
      }
    } catch (error) {
      toastFailed("error message");
    }
  }
  return (
    <>
      {loading ? <Loader /> : null}
      <section className="dashboard">
        <div className="dashboardHeading">
          <div>
            <h1>Investment Packages</h1>
            <h5>
              Choose the perfect investment package for your financial goals
            </h5>
          </div>
          <div className="divTime">
            <div className="timeDashboard">
              <i>
                <Calendar style={{ height: "16px" }} />
              </i>
              <span>
                {currentTime.toLocaleDateString("en-US", {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </span>
            </div>
            <div className="timeDashboard">
              <i>
                <Clock style={{ height: "16px" }} />
              </i>
              <span>
                {" "}
                {currentTime.toLocaleTimeString("en-US", {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </span>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div className="addfundDiv inputPrimary ">
            <h1>Activation</h1>
            <div style={{ width: "fit-content", marginLeft: "auto" }}>
              <AppKitProvider />
            </div>
            {/* <div className="subscriptionWallets">
              {incomeData?.map((x) => {
                return (
                  x?.slug == "fund_wallet" && (
                    <div className="fundWallet" key={x?.name}>
                      <p>{x?.name}</p>
                      <h5>
                        {" "}
                        {companyData?.token_sign}
                        {parseFloat(Math.floor(x?.value * 100) / 100).toFixed(
                          2
                        )}
                      </h5>
                    </div>
                  )
                );
              })}
            </div> */}
            <div className="registerInput_inner">
              <label>User ID</label>
              <input
                type="text"
                id="sponsorId"
                name="sponsorId"
                placeholder="User ID"
                value={profileData?.username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            {/* {minAmount && (
                <span
                  style={{
                    marginTop: "0px",
                    color: "var(--colorPrimary)",
                    fontSize: "10px",
                  }}
                >
                  Min. Amount: {companyData?.currency_sign}
                  {minAmount}
                </span>
              )} */}
            <label htmlFor="Amount">Amount({companyData?.currency_sign})</label>
            <input
              type="number"
              className="inputPrimary"
              placeholder="Enter Amount"
              style={{ borderRadius: "10px", padding: "8px 20px" }}
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
            <p className="errorMsg">{amountError}</p>
            {minAmount && maxAmount && (
              <span
              // style={{
              //   marginTop: "0px",
              //   color: "var(--colorPrimary)",
              //   fontSize: "12px",
              // }}
              >
                Min. Amount: {companyData?.currency_sign}
                {minAmount} and Max. Amount: {companyData?.currency_sign}
                {maxAmount}
              </span>
            )}
            <button className="btnPrimary mt-3" onClick={DepositFunc}>
              Proceed
            </button>
          </div>
        </div>
        <OrderHistory updateOrderList={updateOrderList} />
      </section>
    </>
  );
};

export default Plans;

function PopUp({ TopUp, orderWithDap, amount, onClose, onTopUpSuccess }) {
  return (
    <>
      <div className="otpSection" style={{ zIndex: "999" }}>
        <div className="PaymentOption">
          <div className="d-flex justify-content-between">
            <div></div>
            <div>
              <p style={{ marginTop: "10px" }} className="textHeading">
                Select Method{" "}
              </p>
            </div>
            <div className="d-flex justify-content-end">
              <button className="popUpCloseButton" onClick={onClose}>
                &times;
              </button>
            </div>
          </div>

          <Row
            md="12"
            style={{ marginTop: "5%", padding: "25px 20px", gap: "10px" }}
          >
            <Col md="6">
              <div className="paymentTypeOption" style={{ display: "flex" }}>
                <img
                  src={CryptoGateway}
                  width="100%"
                  height="130px"
                  style={{ margin: "auto", cursor: "pointer" }}
                  onClick={orderWithDap}
                />
              </div>
            </Col>
            <Col>
              <div className="paymentTypeOption" style={{ display: "flex" }}>
                <img
                  src={FundWallet}
                  width="100%"
                  height="130px"
                  style={{ margin: "auto", cursor: "pointer" }}
                  onClick={TopUp}
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
}
